import { useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { PATIENT_SATISFACTION_STARS } from '@aldebaran/common';
import { cn } from '@/lib/utils';

const STARS = PATIENT_SATISFACTION_STARS.map(Number);

interface StarRatingProps {
  value: number | null;
  onChange: (rating: number) => void;
  disabled?: boolean;
  className?: string;
}

export const StarRating = ({
  value,
  onChange,
  disabled,
  className,
}: StarRatingProps) => {
  const [hovered, setHovered] = useState<number | null>(null);
  const highlighted = hovered ?? value ?? 0;

  return (
    <div
      role="radiogroup"
      aria-label="Note de 1 à 5"
      className={cn('flex justify-center gap-1', className)}
      onMouseLeave={() => setHovered(null)}
    >
      {STARS.map((star) => (
        <button
          key={star}
          type="button"
          role="radio"
          aria-checked={value === star}
          aria-label={`${star} sur 5`}
          disabled={disabled}
          onClick={() => onChange(star)}
          onMouseEnter={() => setHovered(star)}
          className="p-1 disabled:cursor-default"
        >
          <FaStar
            className={cn(
              'size-9 transition-colors',
              star <= highlighted ? 'text-[#ffb806]' : 'text-[#ccd1e0]',
            )}
          />
        </button>
      ))}
    </div>
  );
};
